import { cardVariants, border, trail } from './card.css';
import { Box } from '../box/box';
import { clsx } from 'clsx';

type CardVariant = keyof typeof cardVariants;

type CardProps = {
  disabled?: boolean;
  variant?: CardVariant;
  loadingAnimation?: boolean;
} & React.ComponentProps<typeof Box>;

export const Card = ({
  variant = 'default',
  disabled,
  className,
  loadingAnimation,
  ...props
}: CardProps) => {
  return (
    <Box
      className={clsx(cardVariants[variant], className)}
      style={{
        ...props.css,
        opacity: disabled ? 0.6 : undefined,
      }}
      {...props}
    >
      {loadingAnimation && (
        <div className={border}>
          <div className={trail} />
        </div>
      )}
      {props.children}
    </Box>
  );
};
